module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "poiSalon.1ee5d01c.png";